import AppConfirmDialog from '../../../../components/ui/AppConfirmDialog';
import React, { useState } from 'react';
import DataTableCard from '../../../../components/ui/DataTableCard';
import { Dialog } from 'primereact/dialog';
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import ProductDialog from '../../../../features/policies/components/products/ProductDialog.jsx';
import ViewProduct from '../../../../features/policies/components/products/ViewProduct.jsx';
import { useMountEffect } from 'primereact/hooks';
import apiClient from "../../../../services/api-client";
import StorageHelper from '../../../../utils/storage-helper';
        

export default function ProductList() {
  const [visible, setVisible] = useState(false);
  const [viewVisible, setViewVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [productsAvailable, setProductsAvailable] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const renderActions = (rowData) => {
  

  return (
      <div className="actions-container flex items-center justify-center gap-2">
        <div className="tooltip" data-tip="View">
          <button
            className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
            onClick={() => {
              setViewVisible(true);
              setSelectedRowData(rowData);
            }}
          >
            <i className="pi pi-eye text-lg"></i>
          </button>
        </div>
        <div className="tooltip" data-tip="Edit">
          <button
            className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
            onClick={() => {
              setEditVisible(true);
              setSelectedRowData(rowData);
            }}
          >
            <i className="pi pi-pencil text-lg"></i>
          </button>
        </div>
        <div className="tooltip" data-tip="Delete">
          <button
            className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
            onClick={() => {
              setSelectedRowData(rowData);
              document.getElementById('confirm_delete_group_modal').showModal();
            }}
          >
            <i className="pi pi-times text-lg"></i>
          </button>
        </div>
      </div>
    );
  };

  async function fetchAllProducts() {
    
    let activeProducts = []
    await apiClient.get('policy/products/active', {
      headers: {
        Authorization: 'Bearer ' + StorageHelper.get('token'),
        'Content-Type': 'application/json'
      }
    }).then((response) => {

        let products = response.data.responseBody

        products.forEach(product => {

            activeProducts.push(product)
        });
        console.log(response.data.responseBody)
    });

    setProductsAvailable(activeProducts);
  }

  useMountEffect(() => {
    fetchAllProducts()
});

  const imageBodyTemplate = (url) => { 
    return <img src={url.groupImageBannerUrl} alt="No Group Artwork" className="w-2rem shadow-2 border-round" style={{ width: '80%' }} />;
  };

  const productCounter = (url) => {
    //console.log(url.planProducts)
    return <>{url?.planProducts.length} </>;
  };
  const cols = [
     { field: 'index', header: '#' },
    { field: 'groupImageBannerUrl', header: 'Artwork', body: imageBodyTemplate, exportable: false, style: { width: '3rem' } },
    { field: 'easipolSubGroupId', header: 'Group ID' },
    { field: 'activeStatus', header: 'Status' },
    { field: 'easipolPolicySubGroup.Description', header: 'Name' },
    { field: 'easipolPolicySubGroup.planProducts', header: 'No of Products', body: productCounter, exportable: false },
    { field: 'category', header: 'Category' },
    { field: 'activeStatus', header: 'is Active' },
    // { field: 'easipolPolicySubGroup.CommunicationContactNumber', header: 'Contact Number' },
    { field: 'actions', body: renderActions, style: { textAlign: 'center' } },
  ];
  const viewProductTemplate = (rowData)=>{
    return (
      <Dialog header="" visible={viewVisible}  maximizable style={{ width: '80vw' }} onHide={() => setViewVisible(false)}>
            <div>
                <ViewProduct rowData={rowData} onCloseDialog={handleViewProduct} style={{ marginTop: '20px' }} />
            </div>
      </Dialog>
    )
  }

  const handleProductSaved = () => {
    window.location.reload()
  }

  const handleViewProduct = async () => {
    //console.log("clicked")
    setViewVisible(false)
  }

  const handleDeleteGroup = async () => {
    if (!selectedRowData) return;
    await apiClient.delete('policy/products/group/'+selectedRowData.easipolSubGroupId, {
      headers: {
        Authorization: 'Bearer ' + (StorageHelper.get('token'))
      }
    }).then((response) => {
      window.location.reload()
      //console.log("Done!")
    })
    //console.log(rowData.easipolSubGroupId)
  }
  
  const addButton = (
      <button className="btn btn-primary rounded-full h-10 min-h-0 shadow-sm px-6" onClick={() => setVisible(true)}>
          <i className="pi pi-plus"></i> Add New Product
      </button>
  );

    return (

    <div className="w-full">
      <AppConfirmDialog
        id="confirm_delete_group_modal"
        title="Delete Product Group"
        message="Are you sure you want to delete this product group? This action cannot be undone."
        onConfirm={handleDeleteGroup}
        confirmLabel="Delete"
        confirmStyle="btn-error text-white"
        icon="pi pi-trash"
      />
        <DataTableCard
          title="Active Products List"
          exportName="Products"
          columns={cols}
          rows={productsAvailable.map((item, index) => ({ ...item, index: index + 1 }))}
          emptyMessage="No Products found"
          toolbarExtras={addButton}
          exportDisabled={false}
        >
          <ProductDialog
            visible={visible || editVisible}
            product={editVisible ? selectedRowData : null}
            onHide={() => { setVisible(false); setEditVisible(false); }}
            onSaved={handleProductSaved}
          />

          {viewProductTemplate(selectedRowData)}
        </DataTableCard>
    </div>
  );
}
